import autolinkAndSetTarget from './autolink_and_set_target.js';
import DOMPurify from 'dompurify';

const autoLinkOptions = {
  stripPrefix: false,
  stripTrailingSlash: false,
  newWindow: false,
};

const sanitizeOptions = {
  FORBID_TAGS: ['svg', 'math'],
  ALLOWED_TAGS: ['a', 'br', 'em', 'strong'],
  ALLOWED_ATTR: ['target', 'href', 'rel'],
};

export function safeFormattedMessageBody(input) {
  let output = input;

  /* Autolinker */
  output = autolinkAndSetTarget(output, autoLinkOptions);
  /* Sanitize */
  output = DOMPurify.sanitize(output, sanitizeOptions);

  return output;
}
